import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MonacoTextModule} from '../../../sc-monaco-text/src/app/monaco-text/monaco-text.module';
import {MonacoDocumentEditorModule} from '../../../sc-monaco-document-editor/src/app/monaco-document-editor/monaco-document-editor.module';
import {DocumentDownloaderModule} from '../../../sc-document-downloader/src/app/document-downloader/document-downloader.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    MonacoTextModule,
    MonacoDocumentEditorModule,
    DocumentDownloaderModule
  ],
  providers: [],
  // do not bootstrap the app component when exporting custom elements because an Angular app doesn't run. An ngDoBootstrap
  // function is defined that does nothing.
  // bootstrap: [AppComponent]
})
export class AppModule {
  constructor() { }

  // ngDoBootstrap needs to do nothing when exporting custom elements so that the normal Angular app bootstrap doesn't take place
  ngDoBootstrap() {}
}
